"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgAnvilOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.anvil_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "anvil_outline_svg__transparent_box" },
            React.createElement("path", { className: "anvil_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "anvil_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("path", { d: "M22 7V5H2v6h1c2.47 0 4.3.58 5.15 1.61.49.58.83 1.15.82 3.14V19H5v7h18v-7h-4v-1a2 2 0 012-2 11.36 11.36 0 006-2.45 12.29 12.29 0 004-5.23L31.39 7zm-1 17H7v-3h14zm-4-6v1h-6v-3.24c0-2.12-.32-3.28-1.28-4.43C8.56 10 6.61 9.2 4 9V7h16v7.14A4 4 0 0017 18zm8.78-6A10.36 10.36 0 0122 13.82V9h6.4a10.87 10.87 0 01-2.62 3z", id: "anvil_outline_svg__OUTLINE" })));
}
exports.default = SvgAnvilOutline;
//# sourceMappingURL=AnvilOutline.js.map